module.exports = __webpack_public_path__ + "img/arrow-block-down.61972365.svg";